import { render, staticRenderFns } from "./new_item.vue?vue&type=template&id=84455092&scoped=true"
import script from "./new_item.vue?vue&type=script&lang=js"
export * from "./new_item.vue?vue&type=script&lang=js"
import style0 from "./new_item.vue?vue&type=style&index=0&id=84455092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84455092",
  null
  
)

export default component.exports